export default __webpack_public_path__ + "static/media/expensetracker.92b26884.mp4";